var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "calendar-arrow-day",
      class: [
        { "is-start-date": _vm.isStartDateSelected },
        { "is-end-date": _vm.isEndDateSelected },
        { "is-between-date": _vm.isBetweenDate },
        { error: _vm.errorStatus },
      ],
      style: [
        { "margin-left": _vm.marginLeft },
        { height: _vm.dayHeight + "px" },
      ],
      attrs: {
        id: _vm.dayInDate.format(_vm.dayFormat),
        role: "button",
        disabled: _vm.isDisabled,
        "aria-disabled": _vm.isDisabled,
        tabindex:
          _vm.isStartDateSelected ||
          _vm.isCalendarStartDate ||
          _vm.isCurrentFocus
            ? "0"
            : "-1",
        "aria-label": _vm.ariaLabel,
      },
      on: {
        focus: _vm.bindKeyboardEvents,
        blur: _vm.unbindKeyboardEvents,
        click: function ($event) {
          $event.preventDefault()
          return _vm.updateField($event)
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.updateField($event)
        },
      },
    },
    [
      _c("div", { staticClass: "calendar-arrow-day-selected" }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showBackground,
            expression: "showBackground",
          },
        ],
        staticClass: "calendar-arrow-day-background no-pointer-events",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "calendar-arrow-day-label" }, [
        _vm._v("\n    " + _vm._s(_vm.dayOfMonth) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.hasEvent
        ? _c("span", { staticClass: "calendar-arrow-day-dot" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }